import { render, staticRenderFns } from "./EnterCustomerPhoneForEmailOtp.vue?vue&type=template&id=55130f3b"
import script from "./EnterCustomerPhoneForEmailOtp.vue?vue&type=script&lang=js"
export * from "./EnterCustomerPhoneForEmailOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports